import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
// PrivateRoute restricts access to routes based on authentication status
// and allowed user roles.
import { AuthContext } from '../context/AuthContext';
import { Container, Typography } from '@mui/material';

export default function PrivateRoute({ roles, children }) {
  const { user } = useContext(AuthContext);
  if (!user) return <Navigate to="/login" />;
  if (roles && !roles.includes(user.role)) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography variant="h6" color="error">
          Not authorized to view this page.
        </Typography>
      </Container>
    );
  }
  return children;
}
